/* Bundle cart enforcement: discount self-healing + quantity lock.

   1) DISCOUNT: keeps the tiered BUNDLE% code in sync with the number of DISTINCT
      bundle supplements, re-evaluating on every cart change. Applies/removes the
      code THROUGH Rebuy (remove-then-reapply; Rebuy's applyDiscount does not
      replace an existing code). Tier: 2->10, 3->15, 4-5->20, 6->25, below 2->none.

   2) QUANTITY LOCK: a 90-day bundle item is qty 3 (60-day = 2). Customers may ADD
      supplements and REMOVE a whole supplement (trash, which re-tiers), but may
      NOT change a bundle item's quantity with -/+. The lock runs in JS on every
      Rebuy render and identifies bundle lines two ways for robustness:
        a. the `property-_bundle:byo` class Rebuy adds after a live cart change, and
        b. the product handle in the line's link (always present, so the lock holds
           on a fresh page load / when the cart is opened from another page — the
           case where the class-only CSS lock in theme.liquid does not apply).

   Only lines carrying the hidden `_bundle` property AND one of the 6 supplement
   products count. A customer's own (non-bundle) code is never clobbered. */
(function () {
  'use strict';

  var DEBUG = true;
  function log() { if (DEBUG && window.console) console.log.apply(console, ['[kv-bundle-sync]'].concat([].slice.call(arguments))); }

  var SUPPLEMENTS = {
    8287622758674: 1, 8287622988050: 1, 9989844042002: 1,
    10231627153682: 1, 10222648131858: 1, 10222085243154: 1
  };
  // Unguessable bundle codes (renamed from BUNDLE10/15/20/25 so they can't be
  // guessed or shared). TIER = the code to APPLY for each tier.
  var TIER = { 10: 'K9BYO-L8JKWD', 15: 'K9BYO-S6NZQZ', 20: 'K9BYO-T7F3LY', 25: 'K9BYO-BYDEBW' };
  // Legacy guessable codes stay recognized as "ours" so any in-flight cart that
  // still carries one is migrated to the new code on its next view (the
  // remove-then-reapply below). Remove this list after the old codes are retired.
  var LEGACY = ['BUNDLE10', 'BUNDLE15', 'BUNDLE20', 'BUNDLE25'];
  var OURS = {}; Object.keys(TIER).forEach(function (k) { OURS[TIER[k]] = 1; }); LEGACY.forEach(function (c) { OURS[c] = 1; });

  var busy = false, timer = null, rebuyPoll = null, removeTries = 0;
  var bundleHandles = {}; // product handle -> 1, from the current _bundle cart lines

  function pctFor(n) { return n >= 6 ? 25 : (n >= 4 ? 20 : (n >= 3 ? 15 : (n >= 2 ? 10 : 0))); }

  function rebuyReady() {
    return !!(window.Rebuy && window.Rebuy.SmartCart &&
      typeof window.Rebuy.SmartCart.applyDiscount === 'function' &&
      typeof window.Rebuy.SmartCart.removeDiscount === 'function');
  }

  function waitForRebuy() {
    if (rebuyPoll) return;
    var waited = 0;
    rebuyPoll = setInterval(function () {
      if (rebuyReady()) { clearInterval(rebuyPoll); rebuyPoll = null; schedule(); }
      else if ((waited += 500) > 15000) { clearInterval(rebuyPoll); rebuyPoll = null; log('Rebuy never became ready'); }
    }, 500);
  }

  // ---- Quantity lock ----
  function isBundleItem(item) {
    if (item.className && item.className.indexOf('property-_bundle:byo') !== -1) return true;
    var links = item.querySelectorAll('a[href]');
    for (var a = 0; a < links.length; a++) {
      var href = links[a].getAttribute('href') || '';
      for (var h in bundleHandles) { if (bundleHandles[h] && href.indexOf('/products/' + h) !== -1) return true; }
    }
    return false;
  }
  function lockBundleQty() {
    var items = document.querySelectorAll('.rebuy-cart__flyout-item');
    for (var i = 0; i < items.length; i++) {
      if (!isBundleItem(items[i])) continue;
      var qty = items[i].querySelector('.rebuy-cart__flyout-item-quantity') || items[i].querySelector('[class*="quantity"]');
      if (qty && qty.getAttribute('data-kv-locked') !== '1') {
        qty.style.pointerEvents = 'none';
        qty.style.opacity = '0.5';
        qty.setAttribute('data-kv-locked', '1');
        qty.setAttribute('title', 'Bundle quantity is fixed. Remove the item to change your bundle.');
      }
    }
  }

  function reconcile() {
    if (busy) return;
    busy = true;
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' }, credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var items = (cart && cart.items) || [];
        var distinct = {}, hnd = {};
        items.forEach(function (i) {
          if (i.properties && i.properties._bundle && SUPPLEMENTS[i.product_id] && i.quantity > 0) {
            distinct[i.product_id] = 1;
            if (i.handle) hnd[i.handle] = 1;
          }
        });
        bundleHandles = hnd;
        lockBundleQty();

        var n = Object.keys(distinct).length;
        var target = pctFor(n) ? TIER[pctFor(n)] : null;

        var codes = (cart.discount_codes || []).map(function (d) { return d.code; });
        var currentOurs = codes.filter(function (c) { return OURS[c]; })[0] || null;
        var hasOther = codes.some(function (c) { return !OURS[c]; });

        log('distinct=' + n, 'target=' + target, 'current=' + currentOurs, 'codes=' + JSON.stringify(codes), 'rebuyReady=' + rebuyReady());

        if (hasOther) return;
        if (currentOurs === target) { removeTries = 0; return; }
        if (!rebuyReady()) { waitForRebuy(); return; }

        if (currentOurs) {
          if (removeTries >= 4) { log('removeDiscount not taking after retries; giving up'); return; }
          removeTries++;
          log('removeDiscount() ->', currentOurs);
          window.Rebuy.SmartCart.removeDiscount();
          setTimeout(schedule, 900);
        } else if (target) {
          removeTries = 0;
          log('applyDiscount() ->', target);
          window.Rebuy.SmartCart.applyDiscount(target);
        }
      })
      .catch(function (e) { log('reconcile error', e); })
      .then(function () { busy = false; });
  }

  function schedule() { clearTimeout(timer); timer = setTimeout(reconcile, 350); }

  [
    'rebuy:cart:updated', 'rebuy:cart:opened', 'rebuy:cart:loaded', 'cart:updated', 'cart:refresh',
    'rebuy:cart.change', 'rebuy:smartcart.line-item-removed',
    'rebuy:smartcart.line-item-decrease', 'rebuy:smartcart.line-item-increase'
  ].forEach(function (ev) { document.addEventListener(ev, function () { lockBundleQty(); schedule(); }); });

  function isCartMutation(url, method) {
    try { return /post/i.test(method || 'post') && /\/cart\/(add|change|update|clear)(\.js)?/.test(String(url)); }
    catch (e) { return false; }
  }
  var of = window.fetch;
  if (typeof of === 'function') {
    window.fetch = function (input, init) {
      var p = of.apply(this, arguments);
      try {
        var url = (typeof input === 'string') ? input : (input && input.url);
        var method = (init && init.method) || (input && input.method);
        if (isCartMutation(url, method)) p.then(schedule, function () {});
      } catch (e) {}
      return p;
    };
  }

  // Watch the Rebuy cart DOM: re-lock qty + reconcile on every settled re-render
  // (covers fresh loads / opening the cart from another page, and trashing items).
  (function attachObserver() {
    var el = document.getElementById('rebuy-cart');
    if (el && window.MutationObserver) {
      new MutationObserver(function () { lockBundleQty(); schedule(); }).observe(el, { childList: true, subtree: true });
      log('observer attached');
    } else {
      setTimeout(attachObserver, 1000);
    }
  })();

  log('loaded');
  if (document.readyState !== 'loading') schedule();
  else document.addEventListener('DOMContentLoaded', schedule);
  document.addEventListener('visibilitychange', function () { if (!document.hidden) schedule(); });
})();
